export default {
    pathToArray: (path) => path.split(/[:?/]/).filter((pathname) => pathname.trim().length > 0),
};
//# sourceMappingURL=path.js.map